/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-9ecdf98c.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _circle, _circle2, _path138, _circle3, _circle4, _path139, _circle5, _circle6, _path140, _circle7, _circle8, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _circle9, _circle10, _path405, _path406, _circle11, _circle12, _path407, _path408, _circle13, _circle14, _path409, _path410, _circle15, _circle16, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _circle17, _path446, _path447, _path448, _circle18, _path449, _path450, _path451, _circle19, _path452, _path453, _path454, _circle20, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var didWarnAboutDeprecation = {};
var WatsonHealthStackedScrolling_132 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_132(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_124 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_124(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_120 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_120(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_116 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_116(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_232 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_232(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_224 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_224(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_220 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_220(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var WatsonHealthStackedScrolling_216 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_216(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var Stamp32 = /*#__PURE__*/React.forwardRef(function Stamp32(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
var Stamp24 = /*#__PURE__*/React.forwardRef(function Stamp24(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
var Stamp20 = /*#__PURE__*/React.forwardRef(function Stamp20(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
var Stamp16 = /*#__PURE__*/React.forwardRef(function Stamp16(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
var Star32 = /*#__PURE__*/React.forwardRef(function Star32(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var Star24 = /*#__PURE__*/React.forwardRef(function Star24(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var Star20 = /*#__PURE__*/React.forwardRef(function Star20(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var Star16 = /*#__PURE__*/React.forwardRef(function Star16(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1\tl0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7\tL8,1z"
  })), children);
});
var StarFilled32 = /*#__PURE__*/React.forwardRef(function StarFilled32(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var StarFilled24 = /*#__PURE__*/React.forwardRef(function StarFilled24(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var StarFilled20 = /*#__PURE__*/React.forwardRef(function StarFilled20(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
var StarFilled16 = /*#__PURE__*/React.forwardRef(function StarFilled16(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z"
  })), children);
});
var StarHalf32 = /*#__PURE__*/React.forwardRef(function StarHalf32(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
  })), children);
});
var StarHalf24 = /*#__PURE__*/React.forwardRef(function StarHalf24(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
  })), children);
});
var StarHalf20 = /*#__PURE__*/React.forwardRef(function StarHalf20(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
  })), children);
});
var StarHalf16 = /*#__PURE__*/React.forwardRef(function StarHalf16(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
  })), children);
});
var StarReview32 = /*#__PURE__*/React.forwardRef(function StarReview32(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
var StarReview24 = /*#__PURE__*/React.forwardRef(function StarReview24(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
var StarReview20 = /*#__PURE__*/React.forwardRef(function StarReview20(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
var StarReview16 = /*#__PURE__*/React.forwardRef(function StarReview16(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
var WatsonHealthStatusAcknowledge32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge32(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
var WatsonHealthStatusAcknowledge24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge24(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
var WatsonHealthStatusAcknowledge20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge20(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
var WatsonHealthStatusAcknowledge16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge16(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
var WatsonHealthStatusChange32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
  })), children);
});
var WatsonHealthStatusChange24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange24(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
  })), children);
});
var WatsonHealthStatusChange20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange20(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
  })), children);
});
var WatsonHealthStatusChange16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange16(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
  })), children);
});
var WatsonHealthStatusPartialFail32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
var WatsonHealthStatusPartialFail24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail24(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
var WatsonHealthStatusPartialFail20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail20(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
var WatsonHealthStatusPartialFail16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail16(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
var WatsonHealthStatusResolved32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved32(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
var WatsonHealthStatusResolved24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved24(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
var WatsonHealthStatusResolved20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved20(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
var WatsonHealthStatusResolved16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved16(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
var StayInside32 = /*#__PURE__*/React.forwardRef(function StayInside32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
var StayInside24 = /*#__PURE__*/React.forwardRef(function StayInside24(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
var StayInside20 = /*#__PURE__*/React.forwardRef(function StayInside20(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
var StayInside16 = /*#__PURE__*/React.forwardRef(function StayInside16(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
var StemLeafPlot32 = /*#__PURE__*/React.forwardRef(function StemLeafPlot32(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
  })), children);
});
var StemLeafPlot24 = /*#__PURE__*/React.forwardRef(function StemLeafPlot24(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
  })), children);
});
var StemLeafPlot20 = /*#__PURE__*/React.forwardRef(function StemLeafPlot20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
  })), children);
});
var StemLeafPlot16 = /*#__PURE__*/React.forwardRef(function StemLeafPlot16(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
  })), children);
});
var Stethoscope32 = /*#__PURE__*/React.forwardRef(function Stethoscope32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
var Stethoscope24 = /*#__PURE__*/React.forwardRef(function Stethoscope24(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
var Stethoscope20 = /*#__PURE__*/React.forwardRef(function Stethoscope20(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
var Stethoscope16 = /*#__PURE__*/React.forwardRef(function Stethoscope16(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
var Stop32 = /*#__PURE__*/React.forwardRef(function Stop32(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var Stop24 = /*#__PURE__*/React.forwardRef(function Stop24(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var Stop20 = /*#__PURE__*/React.forwardRef(function Stop20(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var Stop16 = /*#__PURE__*/React.forwardRef(function Stop16(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
  })), children);
});
var StopFilled32 = /*#__PURE__*/React.forwardRef(function StopFilled32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var StopFilled24 = /*#__PURE__*/React.forwardRef(function StopFilled24(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var StopFilled20 = /*#__PURE__*/React.forwardRef(function StopFilled20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), children);
});
var StopFilled16 = /*#__PURE__*/React.forwardRef(function StopFilled16(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
  })), children);
});
var StopFilledAlt32 = /*#__PURE__*/React.forwardRef(function StopFilledAlt32(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var StopFilledAlt24 = /*#__PURE__*/React.forwardRef(function StopFilledAlt24(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var StopFilledAlt20 = /*#__PURE__*/React.forwardRef(function StopFilledAlt20(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var StopFilledAlt16 = /*#__PURE__*/React.forwardRef(function StopFilledAlt16(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
var StopOutline32 = /*#__PURE__*/React.forwardRef(function StopOutline32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), children);
});
var StopOutline24 = /*#__PURE__*/React.forwardRef(function StopOutline24(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), children);
});
var StopOutline20 = /*#__PURE__*/React.forwardRef(function StopOutline20(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), children);
});
var StopOutline16 = /*#__PURE__*/React.forwardRef(function StopOutline16(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
  })), children);
});
var StopOutlineFilled32 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled32(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V20H12z"
  })), children);
});
var StopOutlineFilled24 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled24(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V20H12z"
  })), children);
});
var StopOutlineFilled20 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled20(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V20H12z"
  })), children);
});
var StopOutlineFilled16 = /*#__PURE__*/React.forwardRef(function StopOutlineFilled16(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6z"
  })), children);
});
var StopSign32 = /*#__PURE__*/React.forwardRef(function StopSign32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
var StopSign24 = /*#__PURE__*/React.forwardRef(function StopSign24(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
var StopSign20 = /*#__PURE__*/React.forwardRef(function StopSign20(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
var StopSign16 = /*#__PURE__*/React.forwardRef(function StopSign16(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
var StopSignFilled32 = /*#__PURE__*/React.forwardRef(function StopSignFilled32(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
var StopSignFilled24 = /*#__PURE__*/React.forwardRef(function StopSignFilled24(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
var StopSignFilled20 = /*#__PURE__*/React.forwardRef(function StopSignFilled20(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
var StopSignFilled16 = /*#__PURE__*/React.forwardRef(function StopSignFilled16(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
var StoragePool32 = /*#__PURE__*/React.forwardRef(function StoragePool32(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
  })), children);
});
var StoragePool24 = /*#__PURE__*/React.forwardRef(function StoragePool24(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
  })), children);
});
var StoragePool20 = /*#__PURE__*/React.forwardRef(function StoragePool20(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
  })), children);
});
var StoragePool16 = /*#__PURE__*/React.forwardRef(function StoragePool16(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
  })), children);
});
var StorageRequest32 = /*#__PURE__*/React.forwardRef(function StorageRequest32(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
var StorageRequest24 = /*#__PURE__*/React.forwardRef(function StorageRequest24(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
var StorageRequest20 = /*#__PURE__*/React.forwardRef(function StorageRequest20(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
var StorageRequest16 = /*#__PURE__*/React.forwardRef(function StorageRequest16(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
var Store32 = /*#__PURE__*/React.forwardRef(function Store32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
var Store24 = /*#__PURE__*/React.forwardRef(function Store24(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
var Store20 = /*#__PURE__*/React.forwardRef(function Store20(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
var Store16 = /*#__PURE__*/React.forwardRef(function Store16(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
var StormTracker32 = /*#__PURE__*/React.forwardRef(function StormTracker32(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
var StormTracker24 = /*#__PURE__*/React.forwardRef(function StormTracker24(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
var StormTracker20 = /*#__PURE__*/React.forwardRef(function StormTracker20(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
var StormTracker16 = /*#__PURE__*/React.forwardRef(function StormTracker16(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
var Strawberry32 = /*#__PURE__*/React.forwardRef(function Strawberry32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
  })), children);
});
var Strawberry24 = /*#__PURE__*/React.forwardRef(function Strawberry24(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
  })), children);
});
var Strawberry20 = /*#__PURE__*/React.forwardRef(function Strawberry20(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
  })), children);
});
var Strawberry16 = /*#__PURE__*/React.forwardRef(function Strawberry16(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
  })), children);
});
var WatsonHealthStressBreathEditor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor32(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
  })), children);
});
var WatsonHealthStressBreathEditor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor24(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
  })), children);
});
var WatsonHealthStressBreathEditor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor20(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
  })), children);
});
var WatsonHealthStressBreathEditor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor16(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
  })), children);
});
var StringInteger32 = /*#__PURE__*/React.forwardRef(function StringInteger32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
var StringInteger24 = /*#__PURE__*/React.forwardRef(function StringInteger24(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
var StringInteger20 = /*#__PURE__*/React.forwardRef(function StringInteger20(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
var StringInteger16 = /*#__PURE__*/React.forwardRef(function StringInteger16(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
var StringText32 = /*#__PURE__*/React.forwardRef(function StringText32(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
  })), children);
});
var StringText24 = /*#__PURE__*/React.forwardRef(function StringText24(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
  })), children);
});
var StringText20 = /*#__PURE__*/React.forwardRef(function StringText20(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
  })), children);
});
var StringText16 = /*#__PURE__*/React.forwardRef(function StringText16(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
  })), children);
});
var WatsonHealthStudyNext32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyNext24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext24(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyNext20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext20(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyNext16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext16(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyPrevious32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious32(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyPrevious24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious24(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyPrevious20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious20(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyPrevious16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious16(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
var WatsonHealthStudyRead32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead32(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
var WatsonHealthStudyRead24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead24(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
var WatsonHealthStudyRead20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead20(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
var WatsonHealthStudyRead16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead16(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
var WatsonHealthStudySkip32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip32(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
  })), children);
});
var WatsonHealthStudySkip24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip24(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
  })), children);
});
var WatsonHealthStudySkip20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
  })), children);
});
var WatsonHealthStudySkip16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip16(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
  })), children);
});
var WatsonHealthStudyTransfer32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer32(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
var WatsonHealthStudyTransfer24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer24(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
var WatsonHealthStudyTransfer20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer20(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
var WatsonHealthStudyTransfer16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer16(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
var WatsonHealthStudyUnread32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread32(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
var WatsonHealthStudyUnread24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread24(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
var WatsonHealthStudyUnread20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread20(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
var WatsonHealthStudyUnread16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread16(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
var WatsonHealthStudyView32 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView32(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
var WatsonHealthStudyView24 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView24(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
var WatsonHealthStudyView20 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView20(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
var WatsonHealthStudyView16 = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView16(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
var WatsonHealthSubVolume32 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume32(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
var WatsonHealthSubVolume24 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume24(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
var WatsonHealthSubVolume20 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume20(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
var WatsonHealthSubVolume16 = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume16(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
var Subdirectory32 = /*#__PURE__*/React.forwardRef(function Subdirectory32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
var Subdirectory24 = /*#__PURE__*/React.forwardRef(function Subdirectory24(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
var Subdirectory20 = /*#__PURE__*/React.forwardRef(function Subdirectory20(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
var Subdirectory16 = /*#__PURE__*/React.forwardRef(function Subdirectory16(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
var Subflow32 = /*#__PURE__*/React.forwardRef(function Subflow32(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
var Subflow24 = /*#__PURE__*/React.forwardRef(function Subflow24(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
var Subflow20 = /*#__PURE__*/React.forwardRef(function Subflow20(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
var Subflow16 = /*#__PURE__*/React.forwardRef(function Subflow16(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
var SubflowLocal32 = /*#__PURE__*/React.forwardRef(function SubflowLocal32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
  })), children);
});
var SubflowLocal24 = /*#__PURE__*/React.forwardRef(function SubflowLocal24(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
  })), children);
});
var SubflowLocal20 = /*#__PURE__*/React.forwardRef(function SubflowLocal20(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
  })), children);
});
var SubflowLocal16 = /*#__PURE__*/React.forwardRef(function SubflowLocal16(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
  })), children);
});
var SubnetAclRules32 = /*#__PURE__*/React.forwardRef(function SubnetAclRules32(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
var SubnetAclRules24 = /*#__PURE__*/React.forwardRef(function SubnetAclRules24(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
var SubnetAclRules20 = /*#__PURE__*/React.forwardRef(function SubnetAclRules20(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
var SubnetAclRules16 = /*#__PURE__*/React.forwardRef(function SubnetAclRules16(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
var Subtract32 = /*#__PURE__*/React.forwardRef(function Subtract32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var Subtract24 = /*#__PURE__*/React.forwardRef(function Subtract24(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var Subtract20 = /*#__PURE__*/React.forwardRef(function Subtract20(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var Subtract16 = /*#__PURE__*/React.forwardRef(function Subtract16(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var SubtractAlt32 = /*#__PURE__*/React.forwardRef(function SubtractAlt32(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var SubtractAlt24 = /*#__PURE__*/React.forwardRef(function SubtractAlt24(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var SubtractAlt20 = /*#__PURE__*/React.forwardRef(function SubtractAlt20(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var SubtractAlt16 = /*#__PURE__*/React.forwardRef(function SubtractAlt16(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
var SubtractFilled32 = /*#__PURE__*/React.forwardRef(function SubtractFilled32(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
var SubtractFilled24 = /*#__PURE__*/React.forwardRef(function SubtractFilled24(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
var SubtractFilled20 = /*#__PURE__*/React.forwardRef(function SubtractFilled20(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
var SubtractFilled16 = /*#__PURE__*/React.forwardRef(function SubtractFilled16(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
var SubtractLarge32 = /*#__PURE__*/React.forwardRef(function SubtractLarge32(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
var SubtractLarge24 = /*#__PURE__*/React.forwardRef(function SubtractLarge24(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
var SubtractLarge20 = /*#__PURE__*/React.forwardRef(function SubtractLarge20(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
var SubtractLarge16 = /*#__PURE__*/React.forwardRef(function SubtractLarge16(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
var SummaryKpi32 = /*#__PURE__*/React.forwardRef(function SummaryKpi32(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
var SummaryKpi24 = /*#__PURE__*/React.forwardRef(function SummaryKpi24(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
var SummaryKpi20 = /*#__PURE__*/React.forwardRef(function SummaryKpi20(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
var SummaryKpi16 = /*#__PURE__*/React.forwardRef(function SummaryKpi16(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
var SummaryKpiMirror32 = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror32(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
  })), children);
});
var SummaryKpiMirror24 = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror24(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
  })), children);
});
var SummaryKpiMirror20 = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror20(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
  })), children);
});
var SummaryKpiMirror16 = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror16(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
  })), children);
});
var Sun32 = /*#__PURE__*/React.forwardRef(function Sun32(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sun24 = /*#__PURE__*/React.forwardRef(function Sun24(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sun20 = /*#__PURE__*/React.forwardRef(function Sun20(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sun16 = /*#__PURE__*/React.forwardRef(function Sun16(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sunny32 = /*#__PURE__*/React.forwardRef(function Sunny32(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny32']) {
      didWarnAboutDeprecation['Sunny32'] = true;
      console.warn("The Sunny32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sunny24 = /*#__PURE__*/React.forwardRef(function Sunny24(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny24']) {
      didWarnAboutDeprecation['Sunny24'] = true;
      console.warn("The Sunny24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sunny20 = /*#__PURE__*/React.forwardRef(function Sunny20(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny20']) {
      didWarnAboutDeprecation['Sunny20'] = true;
      console.warn("The Sunny20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sunny16 = /*#__PURE__*/React.forwardRef(function Sunny16(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny16']) {
      didWarnAboutDeprecation['Sunny16'] = true;
      console.warn("The Sunny16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
var Sunrise32 = /*#__PURE__*/React.forwardRef(function Sunrise32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
var Sunrise24 = /*#__PURE__*/React.forwardRef(function Sunrise24(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
var Sunrise20 = /*#__PURE__*/React.forwardRef(function Sunrise20(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
var Sunrise16 = /*#__PURE__*/React.forwardRef(function Sunrise16(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
var Sunset32 = /*#__PURE__*/React.forwardRef(function Sunset32(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
var Sunset24 = /*#__PURE__*/React.forwardRef(function Sunset24(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
var Sunset20 = /*#__PURE__*/React.forwardRef(function Sunset20(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
var Sunset16 = /*#__PURE__*/React.forwardRef(function Sunset16(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
var SupportVectorMachine32 = /*#__PURE__*/React.forwardRef(function SupportVectorMachine32(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2zM6 18c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2z"
  })), children);
});
var SupportVectorMachine24 = /*#__PURE__*/React.forwardRef(function SupportVectorMachine24(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2zM6 18c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2z"
  })), children);
});
var SupportVectorMachine20 = /*#__PURE__*/React.forwardRef(function SupportVectorMachine20(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2zM6 18c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2z"
  })), children);
});
var SupportVectorMachine16 = /*#__PURE__*/React.forwardRef(function SupportVectorMachine16(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2zM6 18c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4zm0-6c-1.1028 0-2 .8972-2 2s.8972 2 2 2 2-.8972 2-2-.8972-2-2-2z"
  })), children);
});
var Sustainability32 = /*#__PURE__*/React.forwardRef(function Sustainability32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
var Sustainability24 = /*#__PURE__*/React.forwardRef(function Sustainability24(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
var Sustainability20 = /*#__PURE__*/React.forwardRef(function Sustainability20(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
var Sustainability16 = /*#__PURE__*/React.forwardRef(function Sustainability16(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
var Svg32 = /*#__PURE__*/React.forwardRef(function Svg32(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
var Svg24 = /*#__PURE__*/React.forwardRef(function Svg24(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
var Svg20 = /*#__PURE__*/React.forwardRef(function Svg20(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
var Svg16 = /*#__PURE__*/React.forwardRef(function Svg16(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
  })), children);
});
var Swim32 = /*#__PURE__*/React.forwardRef(function Swim32(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
  })), children);
});
var Swim24 = /*#__PURE__*/React.forwardRef(function Swim24(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
  })), children);
});
var Swim20 = /*#__PURE__*/React.forwardRef(function Swim20(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
  })), children);
});
var Swim16 = /*#__PURE__*/React.forwardRef(function Swim16(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
  })), children);
});
var SwitchLayer_232 = /*#__PURE__*/React.forwardRef(function SwitchLayer_232(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
var SwitchLayer_224 = /*#__PURE__*/React.forwardRef(function SwitchLayer_224(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
var SwitchLayer_220 = /*#__PURE__*/React.forwardRef(function SwitchLayer_220(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
var SwitchLayer_216 = /*#__PURE__*/React.forwardRef(function SwitchLayer_216(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
var SwitchLayer_332 = /*#__PURE__*/React.forwardRef(function SwitchLayer_332(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
var SwitchLayer_324 = /*#__PURE__*/React.forwardRef(function SwitchLayer_324(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
var SwitchLayer_320 = /*#__PURE__*/React.forwardRef(function SwitchLayer_320(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
var SwitchLayer_316 = /*#__PURE__*/React.forwardRef(function SwitchLayer_316(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
var Switcher32 = /*#__PURE__*/React.forwardRef(function Switcher32(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
  })), children);
});
var Switcher24 = /*#__PURE__*/React.forwardRef(function Switcher24(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
  })), children);
});
var Switcher20 = /*#__PURE__*/React.forwardRef(function Switcher20(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
  })), children);
});
var Switcher16 = /*#__PURE__*/React.forwardRef(function Switcher16(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
  })), children);
});
var SysProvision32 = /*#__PURE__*/React.forwardRef(function SysProvision32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
var SysProvision24 = /*#__PURE__*/React.forwardRef(function SysProvision24(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
var SysProvision20 = /*#__PURE__*/React.forwardRef(function SysProvision20(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
var SysProvision16 = /*#__PURE__*/React.forwardRef(function SysProvision16(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
var QT32 = /*#__PURE__*/React.forwardRef(function QT32(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
var QT24 = /*#__PURE__*/React.forwardRef(function QT24(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
var QT20 = /*#__PURE__*/React.forwardRef(function QT20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
var QT16 = /*#__PURE__*/React.forwardRef(function QT16(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
var QTAlt32 = /*#__PURE__*/React.forwardRef(function QTAlt32(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
var QTAlt24 = /*#__PURE__*/React.forwardRef(function QTAlt24(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
var QTAlt20 = /*#__PURE__*/React.forwardRef(function QTAlt20(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
var QTAlt16 = /*#__PURE__*/React.forwardRef(function QTAlt16(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
var Table32 = /*#__PURE__*/React.forwardRef(function Table32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
  })), children);
});
var Table24 = /*#__PURE__*/React.forwardRef(function Table24(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
  })), children);
});
var Table20 = /*#__PURE__*/React.forwardRef(function Table20(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
  })), children);
});
var Table16 = /*#__PURE__*/React.forwardRef(function Table16(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
  })), children);
});
var TableAlias32 = /*#__PURE__*/React.forwardRef(function TableAlias32(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
var TableAlias24 = /*#__PURE__*/React.forwardRef(function TableAlias24(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});

export { QT16, QT20, QT24, QT32, QTAlt16, QTAlt20, QTAlt24, QTAlt32, Stamp16, Stamp20, Stamp24, Stamp32, Star16, Star20, Star24, Star32, StarFilled16, StarFilled20, StarFilled24, StarFilled32, StarHalf16, StarHalf20, StarHalf24, StarHalf32, StarReview16, StarReview20, StarReview24, StarReview32, StayInside16, StayInside20, StayInside24, StayInside32, StemLeafPlot16, StemLeafPlot20, StemLeafPlot24, StemLeafPlot32, Stethoscope16, Stethoscope20, Stethoscope24, Stethoscope32, Stop16, Stop20, Stop24, Stop32, StopFilled16, StopFilled20, StopFilled24, StopFilled32, StopFilledAlt16, StopFilledAlt20, StopFilledAlt24, StopFilledAlt32, StopOutline16, StopOutline20, StopOutline24, StopOutline32, StopOutlineFilled16, StopOutlineFilled20, StopOutlineFilled24, StopOutlineFilled32, StopSign16, StopSign20, StopSign24, StopSign32, StopSignFilled16, StopSignFilled20, StopSignFilled24, StopSignFilled32, StoragePool16, StoragePool20, StoragePool24, StoragePool32, StorageRequest16, StorageRequest20, StorageRequest24, StorageRequest32, Store16, Store20, Store24, Store32, StormTracker16, StormTracker20, StormTracker24, StormTracker32, Strawberry16, Strawberry20, Strawberry24, Strawberry32, StringInteger16, StringInteger20, StringInteger24, StringInteger32, StringText16, StringText20, StringText24, StringText32, Subdirectory16, Subdirectory20, Subdirectory24, Subdirectory32, Subflow16, Subflow20, Subflow24, Subflow32, SubflowLocal16, SubflowLocal20, SubflowLocal24, SubflowLocal32, SubnetAclRules16, SubnetAclRules20, SubnetAclRules24, SubnetAclRules32, Subtract16, Subtract20, Subtract24, Subtract32, SubtractAlt16, SubtractAlt20, SubtractAlt24, SubtractAlt32, SubtractFilled16, SubtractFilled20, SubtractFilled24, SubtractFilled32, SubtractLarge16, SubtractLarge20, SubtractLarge24, SubtractLarge32, SummaryKpi16, SummaryKpi20, SummaryKpi24, SummaryKpi32, SummaryKpiMirror16, SummaryKpiMirror20, SummaryKpiMirror24, SummaryKpiMirror32, Sun16, Sun20, Sun24, Sun32, Sunny16, Sunny20, Sunny24, Sunny32, Sunrise16, Sunrise20, Sunrise24, Sunrise32, Sunset16, Sunset20, Sunset24, Sunset32, SupportVectorMachine16, SupportVectorMachine20, SupportVectorMachine24, SupportVectorMachine32, Sustainability16, Sustainability20, Sustainability24, Sustainability32, Svg16, Svg20, Svg24, Svg32, Swim16, Swim20, Swim24, Swim32, SwitchLayer_216, SwitchLayer_220, SwitchLayer_224, SwitchLayer_232, SwitchLayer_316, SwitchLayer_320, SwitchLayer_324, SwitchLayer_332, Switcher16, Switcher20, Switcher24, Switcher32, SysProvision16, SysProvision20, SysProvision24, SysProvision32, Table16, Table20, Table24, Table32, TableAlias24, TableAlias32, WatsonHealthStackedScrolling_116, WatsonHealthStackedScrolling_120, WatsonHealthStackedScrolling_124, WatsonHealthStackedScrolling_132, WatsonHealthStackedScrolling_216, WatsonHealthStackedScrolling_220, WatsonHealthStackedScrolling_224, WatsonHealthStackedScrolling_232, WatsonHealthStatusAcknowledge16, WatsonHealthStatusAcknowledge20, WatsonHealthStatusAcknowledge24, WatsonHealthStatusAcknowledge32, WatsonHealthStatusChange16, WatsonHealthStatusChange20, WatsonHealthStatusChange24, WatsonHealthStatusChange32, WatsonHealthStatusPartialFail16, WatsonHealthStatusPartialFail20, WatsonHealthStatusPartialFail24, WatsonHealthStatusPartialFail32, WatsonHealthStatusResolved16, WatsonHealthStatusResolved20, WatsonHealthStatusResolved24, WatsonHealthStatusResolved32, WatsonHealthStressBreathEditor16, WatsonHealthStressBreathEditor20, WatsonHealthStressBreathEditor24, WatsonHealthStressBreathEditor32, WatsonHealthStudyNext16, WatsonHealthStudyNext20, WatsonHealthStudyNext24, WatsonHealthStudyNext32, WatsonHealthStudyPrevious16, WatsonHealthStudyPrevious20, WatsonHealthStudyPrevious24, WatsonHealthStudyPrevious32, WatsonHealthStudyRead16, WatsonHealthStudyRead20, WatsonHealthStudyRead24, WatsonHealthStudyRead32, WatsonHealthStudySkip16, WatsonHealthStudySkip20, WatsonHealthStudySkip24, WatsonHealthStudySkip32, WatsonHealthStudyTransfer16, WatsonHealthStudyTransfer20, WatsonHealthStudyTransfer24, WatsonHealthStudyTransfer32, WatsonHealthStudyUnread16, WatsonHealthStudyUnread20, WatsonHealthStudyUnread24, WatsonHealthStudyUnread32, WatsonHealthStudyView16, WatsonHealthStudyView20, WatsonHealthStudyView24, WatsonHealthStudyView32, WatsonHealthSubVolume16, WatsonHealthSubVolume20, WatsonHealthSubVolume24, WatsonHealthSubVolume32 };
